import React from 'react';
import LoginForm from '../components/shared/LoginForm';

/**
 * Merchant Login Page
 * ใช้ Shared LoginForm component กับ mode="merchant"
 * 
 * รองรับ:
 * - Merchant login (email/password)
 * - Employee login (email/password)
 * - 2FA verification
 * - Session conflict handling
 */
const LoginPage: React.FC = () => {
  return <LoginForm mode="merchant" />;
};

export default LoginPage;
